import React, { useState, useRef, useEffect } from "react";
import "./App.css";
import {
  SCENARIO_OPTIONS,
  SCENARIOS,
  player1Color,
  player2Color,
} from "./CONST";
import { draw } from "./draw";

const Expandable = ({ children }) => {
  const [expand, setExpand] = useState(false);
  const onPress = () => {
    console.log("?", expand);
    setExpand(!expand);
  };
  return (
    <div
      className={`Expandable Block ${expand ? "Open" : "Close"}`}
      onClick={onPress}
    >
      {children}
    </div>
  );
};

// todos

// - add an update button (check sq22)
// - add a toggle for scenario score lines
// - add a toggle to show deployment
// - add a view toggle for the extra menu toggles

// - add a collpasable core steamroller rules section
// - - killbox details
// - - objective details and measurements
// - - deployment measurements
// - - scoring and winning the game
// - - max number of turns

// - add a core rules section - maybe a diff page
// - - power attacks
// - - ranged modifiers

var d6 = {
  sides: 6,
  roll: function () {
    const randomNumber = Math.floor(Math.random() * this.sides) + 1;
    return randomNumber;
  },
};

function App() {
  const [scenario, setScenario] = useState(SCENARIO_OPTIONS[0].value);
  const [player2, setPlayer2] = useState(false);
  const [width, setWidth] = useState(0);
  const [selectedObjective, setSelectedObjective] = useState();
  const [showZones, setShowZones] = useState(false);
  // SCENARIOS[scenario].objectives[0]
  const specialRules = SCENARIOS[scenario].rules;
  const objectives = SCENARIOS[scenario].objectives;

  const handleSelectScenario = (e) => {
    // setSelectedObjective(SCENARIOS[scenario].objectives[0]);
    setSelectedObjective(undefined);
    setScenario(e.target.value);
  };
  const handlePlayerToggle = () => {
    // setSelectedObjective(SCENARIOS[scenario].objectives[0]);
    setSelectedObjective(undefined);
    setPlayer2(!player2);
  };
  const handleObjectiveToggle = (objective) => {
    if (selectedObjective?.type === objective.type) {
      setSelectedObjective(undefined);
    } else {
      setSelectedObjective(objective);
    }
  };

  const canvasRef = useRef(null);

  const getRandomScenario = () => {
    setSelectedObjective(undefined);
    const rollAd6 = d6.roll();
    setScenario(SCENARIO_OPTIONS[rollAd6 - 1].value);
  };

  useEffect(() => {
    draw({
      canvasRef,
      scenario: SCENARIOS[scenario],
      player2,
      selectedObjective,
      showZones,
    });
  }, [canvasRef, scenario, player2, width, selectedObjective, showZones]);

  useEffect(() => {
    setWidth(canvasRef?.current?.offsetWidth);
  }, [canvasRef]);

  return (
    <div className="App">
      <div className="Block">
        <div className="Element">
          <div className="Row Pressable" onClick={() => getRandomScenario()}>
            <div>Select Scenario</div>
            <div className="Element">
              <div className="IconButton">{`↻`}</div>
            </div>
          </div>
          <div>
            <select
              value={scenario}
              onChange={handleSelectScenario}
              className="Select Element"
            >
              {SCENARIO_OPTIONS.map(({ label, value }) => (
                <option value={value} key={value}>
                  {label}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="Element">
          <div onClick={handlePlayerToggle} className="Center Pressable">
            <input
              type="checkbox"
              id="player"
              name="player"
              className="Checkbox"
              checked={!player2}
              onChange={handlePlayerToggle}
            />
            <label style={{ color: player1Color }}>Player 1</label>
          </div>
          <div onClick={handlePlayerToggle} className="Center Pressable">
            <input
              type="checkbox"
              id="player"
              name="player"
              className="Checkbox"
              checked={player2}
              onChange={handlePlayerToggle}
            />
            <label style={{ color: player2Color }}>Player 2</label>
          </div>
        </div>
        <div className="Row">
          {objectives
            .filter(
              ({ player }) =>
                (player === 1 && !player2) || (player === 2 && player2)
            )
            .map((objective) => (
              <div
                className="Element Center Pressable"
                onClick={() => handleObjectiveToggle(objective)}
                key={objective.player + objective.type + scenario}
              >
                <input
                  type="checkbox"
                  id="player"
                  name="player"
                  className="Checkbox"
                  checked={selectedObjective?.type === objective.type}
                  onChange={() => handleObjectiveToggle(objective)}
                />
                <label style={{ color: player2 ? player2Color : player1Color }}>
                  {objective.type}
                </label>
              </div>
            ))}
        </div>
      </div>
      <div className="Block Square" onClick={() => setShowZones(!showZones)}>
        <canvas
          className="Canvas"
          ref={canvasRef}
          width={width}
          height={width}
        />
      </div>
      <div className="Block">
        {/* <div
          onClick={() => setShowZones(!showZones)}
          className="Center Pressable"
        >
          <input
            type="checkbox"
            id="zones"
            name="zones"
            className="Checkbox"
            checked={showZones}
            onChange={() => setShowZones(!showZones)}
          />
          <label style={{ color: player2Color }}>show zones</label>
        </div> */}
        {specialRules ? (
          specialRules.map((rule) => <div className="Element">{rule}</div>)
        ) : (
          <div>no special rules</div>
        )}
      </div>

      {/* <Expandable>stuff to sayy</Expandable> */}
      {/* <div className="Block">base rules todo</div> */}
    </div>
  );
}

export default App;
